$(".dropdown-menu").click(function(e){
    alert(1);
   e.stopPropagation();
})


// WEBPACK FOOTER //
// /src/assets/js/common.js